import { useSortable } from "@dnd-kit/sortable";
import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { Input } from "../../../../Helpers/Input/Input";

const Items = ({
  id,
  title,
  odometer,
  plate,
  distance,
  selected,
  toggleSelectItem,
  date,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: id,
      data: {
        type: "item",
      },
    });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      {...listeners}
      onDoubleClick={() => toggleSelectItem(id)}
    >
      <div
        className={
          selected ? `item-container item-container-active` : `item-container`
        }
      >
        <div className="items-header">
          <h4>{title}</h4>
          <h4>{odometer}</h4>
        </div>
        <h5>{plate}</h5>
        <div className="item-footer">
          <Input
            title="Next Maintenance Distance"
            type="number"
            placeholder="in KM"
            formstyle="form-input"
            id="distance"
            name="distance"
            value={distance}
          />
          <Input
            title="Next Maintenance Date"
            type="text"
            placeholder="11/2/2025"
            formstyle="form-input"
            id="date"
            name="date"
            value={date}
          />
        </div>
      </div>
    </div>
  );
};

export default Items;
